module.exports = __webpack_public_path__ + "img/numberViews.c8f423b6.svg";